import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import type {
  UserActivityStatus,
  UserSetAvailabilityStatus,
} from '@api/generated/graphql';
import { userStatusToUserSetStatus } from '@modules/ServiceModule/workspace/lib/serviceUserUtils';

const getUserAvailabilityActivityQuery = graphql(`
  query getUserAvailabilityActivity($id: ID!) {
    user(id: $id) {
      id
      availabilityActivityStatus {
        availabilityStatus
        activityStatus
      }
    }
  }
`);

export type UserAvailabilityActivity = {
  id: string;
  availabilityStatus: UserSetAvailabilityStatus;
  activityStatus: UserActivityStatus;
};

export async function getUserAvailabilityActivity(
  userId: string,
): Promise<UserAvailabilityActivity | null> {
  const { data } = await getClient().query({
    query: getUserAvailabilityActivityQuery,
    fetchPolicy: 'network-only',
    variables: { id: userId },
  });

  const user = data?.user;
  const status = user?.availabilityActivityStatus;
  if (!user || !status) {
    return null;
  }

  return {
    id: user.id,
    // Normalize to UserSetAvailabilityStatus so callers can compare against
    // ServiceUser.availabilityStatus without bridging two enums.
    availabilityStatus: userStatusToUserSetStatus(status.availabilityStatus),
    activityStatus: status.activityStatus,
  };
}
